import React from 'react';

import { LoadingPlaceholderProps } from '../../type';
import { LoadingRadialStyle } from './styles';

type PropTypes = LoadingPlaceholderProps;

const LoadingRadial: React.FC<PropTypes> = LoadingRadialStyle;

export default LoadingRadial;
